import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RowActions } from 'src/app/dashboard/admin/report/report';
import Swal from 'sweetalert2';
import { BinProviderDeleteByMerchantIdService } from '../services/bin-provider-deleteByMerchantId.service';
import { BinProviderListService } from '../services/bin-provider-list.service';

@Component({
  selector: 'app-bin-merchant-list',
  templateUrl: './bin-merchant-list.component.html',
  styleUrls: ['./bin-merchant-list.component.scss'],
})
export class BinMerchantListComponent implements OnInit {
  displayTableColumns: { [key: string]: string } = {
    merchantName: 'Merchant'
  };
  properties = ['merchantName'];
  selectFilters = [];
  columnTypes = {}
  loading;
  requestBody: any={};
  data;
  actions: RowActions[] = [
    {
      actionName: 'delete',
      actionType: 'icon',
      iconClass: 'fa fa-trash',
    },
    {
      actionName: 'view',
      actionType: 'icon',
      iconClass: 'fa fa-eye',
    },
  ];
  totalRecords: number;
  itemsPerPage: number = 10;

  constructor(
    private binProviderList: BinProviderListService,
    private binProviderDelete: BinProviderDeleteByMerchantIdService,
    private router: Router,
    private activeRoute: ActivatedRoute
  ) {
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10,
    };
    this.requestBody.filterOptions = {};
  }

  async ngOnInit() {
    await this.updateTable();
  }
  async updateTable() {
    this.binProviderList.setParams(this.requestBody);
    let responseData = await this.binProviderList.make();
    this.totalRecords = responseData.count;
    const response: gateMerchantProviderBinReport[] = responseData.result ?? [];
    this.data = response;
  }

  actionEmiter(event) {
    switch (event.action) {
      case 'delete':
        this.deleteProvider(event.key.merchantId);
        break;
      case 'view':
        this.viewProvider(event.key.merchantName, event.key.merchantId);
        break;
      default:
        break;
    }
  }

  async deleteProvider(merchantId: number) {
    Swal.fire({
      title: 'Are you sure you want to delete this Merchant Provider bin data?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(async (result) => {
      if (result.value) {
        this.binProviderDelete.setParams({ merchantId });
        let responseData = await this.binProviderDelete.make();
        if (responseData.success) {
          await this.updateTable();
        }
      }
    });
  }

  async editProvider(id: number) {
    this.router.navigate([`edit/${id}`], { relativeTo: this.activeRoute });
  }

  async viewProvider(mName: string, mId: string) {
    this.router.navigate([`${mName}`], {
      relativeTo: this.activeRoute,
      state: { merchant: { name: mName, id: mId } },
    });
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.binProviderList.loader().subscribe(val => (this.loading = val));
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.binProviderList.loader().subscribe(val => (this.loading = val));
  }

  async searchChange(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.binProviderList.loader().subscribe(val => (this.loading = val));
    }
    this.updateTable();
  }
  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.binProviderList.loader().subscribe(val => (this.loading = val));
  }
}
interface gateMerchantProviderBinReport {
  merchantId: number;
  merchanName: string;
  providerBins: { provider: string; cardBin: string }[];
}
